import type { ProjectConfig } from './types';

const AideConfig: ProjectConfig = {
  title: 'Aide',
  theme: { accentColor: 'rgb(48, 105, 154)', accentColorStage: 'rgb(46, 120, 185)' },
};

export default AideConfig;
